import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(({
  root: {
    //background: 'rgba(255,255,255,0.55)',
    background: '#f7faff',
    borderRadius: 16
  },
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: 'clamp(15px, 1.4vw, 22px)',
    paddingLeft: 3
  },
  cardHeaderSub: {
    color: '#486d86',
    fontSize: 'clamp(12px, 1vw, 16px)',
    paddingLeft: 3
  },
  cardContent: {
    color: '#486d86',
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: 28
  },
  formLabel: {
    color: '#002D55',
    fontSize: 'clamp(12px, 0.85vw, 14px)',
    fontWeight: 'bold',
  },
  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 22,
    padding: '8px 0',
  },
  item: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: "#FFFFFF",
    borderRadius: 24,
    padding: 16,
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55",
    borderRadius: 18,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    marginRight: 'clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: "#fb741a",
    }
  },
}));

const Notifications = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <form
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card className={clsx(classes.root, className)}>
      <CardHeader
          title={<span className={classes.cardHeaderTitle}>Settings</span>}
          style={{ marginBottom: 0, borderBottom: "2px solid #fb741a", alignItems: 'center' }}
        />
        <Divider />
        <CardContent className={clsx(classes.cardContent, className)}>
          <Typography style={{ marginBottom: 16 }}>Manage notifications and messages.</Typography>
          <div className={classes.itemRow}>
            <div className={classes.item}>
              <Typography
                className={classes.formLabel}
                gutterBottom
                variant="h6"
              >
                Notifications
              </Typography>
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#fb741a"}} icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleIcon />}/>
                )}
                label="Email"
                classes={{ label: classes.formLabel }}
              />
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#fb741a"}} icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleIcon />}/>
                )}
                label="Push Notifications"
                classes={{ label: classes.formLabel }}
              />
              <FormControlLabel
                control={<Checkbox style={{color: "#fb741a"}} icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleIcon />}/>}
                label="Text Messages"
                classes={{ label: classes.formLabel }}
              />
            </div>
            <div className={classes.item}>
              <Typography
                className={classes.formLabel}
                gutterBottom
                variant="h6"
              >
                Messages
              </Typography>
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#fb741a"}} icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleIcon />}/>
                )}
                label="Email"
                classes={{ label: classes.formLabel }}
              />
              <FormControlLabel
                control={<Checkbox style={{color: "#fb741a"}} icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleIcon />}/>}
                label="Push Notifications"
                classes={{ label: classes.formLabel }}
              />
            </div>
          </div>
        </CardContent>
        <Divider style={{marginTop: 13.5}}/>
        <Box
          display="flex"
          justifyContent="flex-end"
          p={2}
          
        >
          <Button
            className={classes.Button}
            variant="contained"
          >
            Save settings
          </Button>
        </Box>
      </Card>
    </form>
  );
};

Notifications.propTypes = {
  className: PropTypes.string
};

export default Notifications;